module.exports = __webpack_public_path__ + "static/media/hdd.a2a0a564.svg";